import React from 'react';
import Eighthgrade_k8 from './eighthgrade_k8';
import Eighthgrade_k8_subjects from './eighthgrade_k8_subjects';
const Eighthgrade_k8math = () => {
  return (
    <div>
      <Eighthgrade_k8 />
    <Eighthgrade_k8_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Mathematics section</h1>
      <h3>Mathematics section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Eighthgrade_k8math;

        


     
  